export const COMUNAS = '/comunas';
